import { SkuBoxStates } from './TestPlanActionsModal.types';

export interface ValidationResult {
  hasError: boolean;
  errorMessage: string;
}

export const getSkuValue = (skuValue: any): string => {
  if (typeof skuValue === 'string') return skuValue.trim();
  return skuValue?.value?.trim() || '';
};

export const validateSkuBox = (skuValue: any, formValues: any): ValidationResult => {
  if (!getSkuValue(skuValue)) {
    return { hasError: false, errorMessage: '' };
  }

  if (!formValues) {
    return { hasError: true, errorMessage: 'At least one set needs to be active.' };
  }

  const hasActiveSets = Object.values(formValues).some((value: any) =>
    typeof value === 'boolean' ? value : value?.offerTransition || value?.tierDowngrade || value?.tierUpgrade,
  );

  if (!hasActiveSets) {
    return { hasError: true, errorMessage: 'At least one set needs to be active.' };
  }

  const { offerTransitions, tierDowngrade, tierUpgrade } = formValues;
  const transitionSets = [
    { enabled: offerTransitions?.offerTransition, transition: offerTransitions?.transition1 },
    { enabled: tierDowngrade?.tierDowngrade, transition: tierDowngrade?.transition1 },
    { enabled: tierUpgrade?.tierUpgrade, transition: tierUpgrade?.transition1 },
  ];

  for (const set of transitionSets) {
    if (set.enabled && !set.transition) {
      return { hasError: true, errorMessage: 'At least one SKU is required for enabled transitions.' };
    }
  }

  return { hasError: false, errorMessage: '' };
};

export const hasIncompleteTransitionsInFormValues = (formValues: any): boolean => {
  if (!formValues) return false;

  const { offerTransitions, tierDowngrade, tierUpgrade } = formValues;
  return (
    (offerTransitions?.offerTransition && !offerTransitions?.transition1) ||
    (tierDowngrade?.tierDowngrade && !tierDowngrade?.transition1) ||
    (tierUpgrade?.tierUpgrade && !tierUpgrade?.transition1)
  );
};

export const hasActiveSetInFormValues = (formValues: any): boolean => {
  if (!formValues) return false;

  return Object.values(formValues).some((value: any) =>
    typeof value === 'boolean' ? value : value?.offerTransition || value?.tierDowngrade || value?.tierUpgrade,
  );
};

export const isSkuBoxValid = (skuValue: any, formValues: any): boolean => {
  if (!getSkuValue(skuValue) || !formValues) return false;

  const hasActiveSet = hasActiveSetInFormValues(formValues);
  if (!hasActiveSet) return false;

  return !hasIncompleteTransitionsInFormValues(formValues);
};
